export const currentUserLocalStorageKey = "BlogAppCurrentUser";
